<template>
  <main class="vh-100 bg-white">
    <RouterView />
  </main>
</template>
